import React, { useState, useEffect } from "react";

const OcenaUrsic = () => {
	const [grade, setGrade] = useState();
	const [source, setSource] = useState("");
	const selectSource = (newSource) => {
		if (newSource === 6) {
			setGrade(6);
		} else {
			setGrade(4);
		}
	};

	useEffect(() => {
		if (grade === 6) {
			setSource(
				"https://docs.google.com/document/d/1LDH-RF5x6vITsOKKSg9QMC0BNV57YkdB5QG_YnowzLU/edit?usp=sharing"
			);
		} else if (grade === 4) {
			setSource(
				"https://docs.google.com/document/d/1297PVl2MtEMDQHJg65vIafhyPePs0USr9rzDKKG3hwo/edit?usp=sharing"
			);
		} else {
			setSource("");
		}
	}, [grade]);
	return (
		<div className='ocena-container'>
			<h1>OCENJEVANJE - URŠIČ</h1>
			<h2>Izberi razred</h2>
			<div className='ocena-razred' onClick={() => selectSource(6)}>
				6. - 9. razred
			</div>
			<div className='ocena-razred' onClick={() => selectSource(4)}>
				4. - 5. razred
			</div>

			<div className='work-google'>
				{source === "" ? (
					<h2>Razred še ni izbran.</h2>
				) : (
					<iframe
						src={source}
						frameborder='0'
						width='1920'
						height='560'
						allowfullscreen='true'
						mozallowfullscreen='true'
						webkitallowfullscreen='true'
					></iframe>
				)}
			</div>
		</div>
	);
};

export default OcenaUrsic;
